var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"width":720,"footer-hide":"","title":"预订单列表","value":_vm.value},on:{"input":(val) => _vm.$emit('input', val)}},[_c('div',[_c('h-table',{attrs:{"size":"small","columns":_vm.table.columns,"data":_vm.table.data,"loading":_vm.table.loading}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }